import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import {fade} from '@material-ui/core/styles/colorManipulator';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SvgCalendar from '@material-ui/icons/DateRange';
import SvgCloud from '@material-ui/icons/CloudQueue';
import SvgLandscape from '@material-ui/icons/Landscape';

import {helper, api} from '../../common/common';

const styles = (theme) => {
    return {
        panel: {
            position: 'relative',
            marginTop: 8,
            marginBottom: 8,
            marginLeft: 16,
            marginRight: 16,
            height: 98,
            borderRadius: 2,
            borderColor: theme.palette.common.transparent,
            borderStyle: 'solid',
            borderWidth: 1,
            cursor: 'pointer',
            '&:hover': {
            },
            '&$selected': {
                borderColor: theme.palette.secondary.main,
            }
        },
        imageContainer: {
            position: 'absolute',
            top: 4,
            bottom: 4,
            left: 4,
            height: 88,
            width: 88,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: fade(theme.palette.primary.mainBorder, 0.05),
        },
        imagePlaceholder: {
            ...theme.iconStyle.size[48],
            ...theme.iconStyle.light,
            margin: 20,
        },
        image: {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            visibility: 'visible',
            '&$error': {
                visibility: 'hidden',
            }
        },
        label: {
            position: 'absolute',
            top: 4,
            bottom: 4,
            left: 96,
            right: 4,
        },
        labelIcon: {
            ...theme.iconStyle.size[18],
            ...theme.iconStyle.dark,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            marginTop: 'auto',
            marginBottom: 'auto',
        },
        textLabel: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 28,
            right: 0,
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '24px',
        },
        dateGroup: {
            position: 'absolute',
            top: 18,
            left: 12,
            right: 4,
            height: 24,
        },
        cloudCoverGroup: {
            position: 'absolute',
            bottom: 18,
            left: 12,
            right: 4,
            height: 24,
        },
        error: {},
        default: {},
        selected: {}
    }
}

class Card extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imgLoadError: false,
        };
    }

    render = () => {
        const {classes} = this.props;

        const selected = (this.props.selectedUid === this.props.info.uid);

        const paperClassName = classNames(classes.panel,
            (selected) ? classes.selected : classes.default);

        const imageClassName = classNames(classes.image,
            (this.state.imgLoadError) ? classes.error : classes.default);

        return (
            <Paper
                className={paperClassName}
                square={false}
                elevation={2}
                onClick={this._handleOnClick}
            >
                <Paper
                    className={classes.imageContainer}
                    elevation={0}
                >
                    <SvgLandscape className={classes.imagePlaceholder}/>
                    <img
                        className={imageClassName}
                        src={api.tasking() +
                            '/image?access_code=' + this.props.getAccessCode() +
                            '&key=' + this.props.info.content[0].key}
                        alt=''
                        onError={this._handleOnError}
                    />
                </Paper>
                <div className={classes.label}>
                    <div className={classes.dateGroup}>
                        <SvgCalendar className={classes.labelIcon}/>
                        <Typography
                            className={classes.textLabel}
                            align='left'
                        >
                            {helper.makeDate(this.props.info.date).toDateString()}
                        </Typography>
                    </div>
                    <div className={classes.cloudCoverGroup}>
                        <SvgCloud className={classes.labelIcon}/>
                        <Typography
                            className={classes.textLabel}
                            align='left'
                        >
                            {this._extractCloudCover()}%
                        </Typography>
                    </div>
                </div>
            </Paper>
        );
    }

    _handleOnClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.info);
        }
    }

    _handleOnError = () => {
        this.setState({
            imgLoadError: true,
        });
    }

    _extractCloudCover = () => {
        return Number(this.props.info.cloudCover / this.props.info.content.length).toFixed(2);
    }
}

Card.propTypes = {
    getAccessCode: PropTypes.func.isRequired,
    info: PropTypes.object.isRequired,
    onClick: PropTypes.func,
}

export default withStyles(styles)(Card);
